var map = {
	"./AED.svg": 58860,
	"./AOA.svg": 2663,
	"./ARS.svg": 26350,
	"./AUD.svg": 43804,
	"./AZN.svg": 89299,
	"./BGN.svg": 75380,
	"./BHD.svg": 89272,
	"./BRL.svg": 84734,
	"./BYN.svg": 99921,
	"./CAD.svg": 52886,
	"./CHF.svg": 18243,
	"./CLP.svg": 93977,
	"./CNY.svg": 79562,
	"./COP.svg": 31712,
	"./CZK.svg": 33788,
	"./DKK.svg": 63476,
	"./EGP.svg": 14426,
	"./EUR.svg": 22942,
	"./GBP.svg": 88323,
	"./HKD.svg": 30991,
	"./HRK.svg": 37075,
	"./HUF.svg": 31723,
	"./IDR.svg": 5577,
	"./ILS.svg": 75152,
	"./INR.svg": 11419,
	"./JOD.svg": 70589,
	"./JPY.svg": 15597,
	"./KRW.svg": 40632,
	"./KWD.svg": 73100,
	"./KZT.svg": 12211,
	"./MXN.svg": 80397,
	"./MYR.svg": 78362,
	"./NGN.svg": 54963,
	"./NOK.svg": 37590,
	"./PHP.svg": 72710,
	"./PLN.svg": 82508,
	"./QAR.svg": 75238,
	"./RON.svg": 15359,
	"./RSD.svg": 92025,
	"./RUB.svg": 43945,
	"./SAR.svg": 44040,
	"./SEK.svg": 66749,
	"./SGD.svg": 67380,
	"./THB.svg": 30760,
	"./TRY.svg": 25309,
	"./TWD.svg": 72239,
	"./UAH.svg": 54992,
	"./USD.svg": 70714,
	"./VND.svg": 41622,
	"./ZAR.svg": 83509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79066;